import TagManager from 'react-gtm-module'
import { canUseDOM } from 'utils'
import { checkPreviousPageExists, setPreviousPageExists } from './webStorage'
import getConstants from './../constants'
import { BRAND_LIST } from 'typings'

const getPageViewData = (ifPreviousPageExists: boolean = false): any => {
  const brand = getConstants().BRAND
  return {
    dataLayer: {
      event: 'trackPageView',
      brand: brand === BRAND_LIST.PL ? brand.toUpperCase() : brand,
      pageType: 'Storelocator',
      pageUrlPath: `${window.location.pathname}${window.location.search}${window.location.hash}`,
      pageTitle: document.title,
      previousPageExists: ifPreviousPageExists,
      content_group: 'store_locator',
      loginState: 'not_login',
      subID: '',
    },
  }
}

export const sendPageViewData = () => {
  if (!canUseDOM || !TagManager.dataLayer) {
    return
  }
  const ifPreviousPageExists = checkPreviousPageExists()
  TagManager.dataLayer(getPageViewData(ifPreviousPageExists))
  setPreviousPageExists('Storelocator')
}

const getSearchClickEventData = (
  resultCount?: number,
  searchTerm?: string,
): any => {
  return {
    dataLayer: {
      event: 'search_26v2',
      search_type: 'store',
      search_type_detail: 'store_locator',
      search_location: 'search',
      search_term: searchTerm || '',
      search_term_raw: searchTerm || '',
      result_count: resultCount || 0,
    },
  }
}
/**
 *
 * @param resultCount
 * @returns
 */

export const trackSearchClickEvent = (
  resultCount?: number,
  searchTerm?: string,
) => {
  if (!canUseDOM || !TagManager.dataLayer) {
    return
  }
  TagManager.dataLayer(getSearchClickEventData(resultCount, searchTerm))
}
